import { CurrencyPipe, PercentPipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { generate, observe } from "fast-json-patch";
import { BaseEntityDisplay, ModalService } from "../../../core/core";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { ComparisonTable } from "../../../tables/tables";
import { InventoryItem, InventoryService } from "../../../inventory/inventory";

@Component({
  selector: "common-machine-item-rpo",
  templateUrl: "./machine-item-rpo.component.html",
  styleUrls: ["./machine-item-rpo.component.scss"],
  providers: [CurrencyPipe, PercentPipe],
})
export class MachineItemRpoComponent extends BaseEntityDisplay implements OnInit {
  entity: InventoryItem;

  comparisonTable: ComparisonTable = {
    headers: [],
    rows: [],
  };

  observer: any;
  monthlyDuration: number = 1;

  constructor(
    private inventoryService: InventoryService,
    toastrService: ToastrService,
    router: Router,
    activatedRoute: ActivatedRoute,
    public modalService: ModalService,
    private currencyPipe: CurrencyPipe,
    private percentPipe: PercentPipe,
  ) {
    super(inventoryService, toastrService, router, activatedRoute, modalService, null, "id", true);
  }

  setupView(entity: InventoryItem) {
    this.entity = entity;

    this.onPurchasePriceChange(entity?.purchasePrice ?? "0");

    this.observer = observe(this.entity);
    return of(entity);
  }

  rentalDurationChange(value) {
    this.monthlyDuration = parseFloat(value);
    this.onPurchasePriceChange(this.entity.purchasePrice);
  }

  onPurchasePriceChange(purchasePrice: string | any) {
    if (typeof purchasePrice === "string") {
      this.entity.purchasePrice = parseFloat(purchasePrice.replace(/,/g, ""));
    } else {
      this.entity.purchasePrice = purchasePrice;
    }

    const rentalDeductionRateConst = 0.8;
    const conversionFeeConst = 0.075;
    const rentDeduction = this.entity.rentalRate * rentalDeductionRateConst * this.monthlyDuration;
    const adjustedPrice = this.entity.purchasePrice - rentDeduction;
    const conversionFee2 = (this.entity.purchasePrice - rentDeduction) * conversionFeeConst;
    const ownerTotal = adjustedPrice - conversionFee2;
    const rubblTotal = adjustedPrice - ownerTotal;
    const rubblPercentage2 = rubblTotal / adjustedPrice;

    let firstRows = [
      {
        columns: [
          {
            label: `Total Rent Applied<br/><div class='fs-14 font-weight-light'>80% of paid rent will be applied payoff price. This amount is ${this.currencyPipe.transform(
              this.entity.rentalRate * rentalDeductionRateConst,
              "USD",
              "symbol",
              "1.0-0",
            )} per month.</div>`,
          },
          { label: `<span class='text-primary mt-3 mt-lg-0'>(${this.currencyPipe.transform(rentDeduction, "USD", "symbol", "1.0-0")})</span>` },
        ],
      },
      {
        columns: [
          { label: "Renter Payoff Price<div class='fs-14 font-weight-light'>This is the renter's final purchase price.</div>" },
          { label: adjustedPrice > 0 ? `<b class='mt-3 mt-lg-0'>${this.currencyPipe.transform(adjustedPrice, "USD", "symbol", "1.0-0")}</b>` : "-" },
        ],
      },
      {
        columns: [
          { label: "<b>Rubbl Conversion Fee</b><br/><div class='fs-14 font-weight-light'>Commission is 7.5% of the renter payoff price price.<div>" },
          {
            label:
              rubblTotal > 0
                ? `<b><span class='text-primary mt-3 mt-lg-0'>(${this.currencyPipe.transform(rubblTotal, "USD", "symbol", "1.0-0")})</span></b>`
                : "-",
          },
        ],
      },
      {
        columns: [
          {
            label:
              "<b>Owner Repair Credit</b><br/><div class='fs-14 font-weight-light'>Any repairs during the rental will be added to the Renter Payoff Price.<div>",
          },
          {
            label: rubblTotal > 0 ? `<b>TBD</b>` : "-",
          },
        ],
      },
    ];

    let thirdRows = [
      {
        columns: [
          { label: "<b>Owner Total Proceeds</b><div class='fs-14 font-weight-light'>This is the final net sale proceeds you will receive.</div>" },
          {
            useCheckmark: true,
            label: ownerTotal > 0 ? `<b class="fs-18 text-success">${this.currencyPipe.transform(ownerTotal, "USD", "symbol", "1.0-0")}</b>` : "-",
          },
        ],
      },
    ];

    this.comparisonTable.rows = [...firstRows, ...thirdRows];
  }

  save() {
    // const patchOperation = this.inventoryService.jsonPatchWithPartitionKey(this.entity.id, this.en);
    const jsonPatch = generate(this.observer);
    if (!jsonPatch.length) {
      this.toastrService.success("Saved");
      return;
    }

    this.inventoryService.jsonPatchWithPartitionKey(this.entity.id, jsonPatch, this.entity.accountId).subscribe(result => {
      this.toastrService.success("Saved");
    });
  }
}
